
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';

@Component({
  selector: 'app-pseg-demand-management',
  templateUrl: './pseg-demand-management.component.html',
  styleUrls: ['./pseg-demand-management.component.css']
})
export class PsegDemandManagementComponent implements OnInit , OnDestroy {

  public destroyed = new Subject<any>();

  constructor() {

  }
  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
